export * from './ecall.module';
export * from './ecall-routing.module';
export * from './ecall-summary';
export * from './ecall-detail';
export * from './ecall-edit';
export * from './ecall-create';
export * from './ecall-pdf-summary';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/index.ts